import { useEffect, useState } from 'react';

/**
 * What just landed in the diary, so its block arrives with a flourish (and
 * Bailey can run over to it) instead of simply being there after a reload.
 *
 * A booking is matched by id. Events and leave are matched by who and when,
 * because their create calls don't hand back an id the diary can use.
 *   { bookingId } | { kind: 'event'|'holiday', staffId, startMinutes? }
 * One at a time, cleared after the animation has played.
 */
const EVENT = 'dv2:highlight-changed';
let current = null;
let timer = null;

export function highlightItem(target, ms = 3200) {
  current = target || null;
  clearTimeout(timer);
  if (current) timer = setTimeout(() => highlightItem(null), ms);
  try { window.dispatchEvent(new CustomEvent(EVENT, { detail: current })); } catch (e) { /* ignore */ }
}

export function highlightBooking(bookingId, ms) {
  highlightItem(bookingId ? { bookingId } : null, ms);
}

export function matchesHighlight(target, event) {
  if (!target || !event) return false;
  if (target.bookingId) return !!event.bookingId && String(event.bookingId) === String(target.bookingId);
  if (target.kind !== event.type) return false;
  if (String(event.staffId) !== String(target.staffId)) return false;
  return target.startMinutes == null || Number(event.startMinutes) === Number(target.startMinutes);
}

export function useHighlight() {
  const [value, setValue] = useState(current);
  useEffect(() => {
    const on = (e) => setValue(e.detail);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return value;
}
